import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import Typography from "../common-components/Typography";
import content from "../constants/content";
import { font } from "../constants/font";
import vmTheme from "../constants/theme";
import { API, API_URL, STATIC_PATH, TIKTOK_URL } from "../constants/config";
import { ConfirmationWrap, Image } from "./publish-component";
import Action from "../common-components/Action";
import useApi from "../helper/hooks/useApi";
import proceedWait from "../helper/proceedWait";
import openUrl from "../helper/openUrl";
import { Modal } from "../common-components/modal";

const PublishSuccess = ({ exportId, onClick }) => {
  const { post } = useApi();
  const theme = useSelector((state) => state.app.get("theme"));
  const { email } = useSelector((state) => state.userDetails);

  const [link, setLink] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isDownload, setIsDownload] = useState(true);
  const [isTikTok, setIsTikTok] = useState(true);
  const [isYoutubeFailed, setisYoutubeFailed] = useState(false);

  const retryCountRef = useRef(0);

  useEffect(() => {
    setIsLoading(true);
    const maxRetries = 5;

    const proceedNewApi = () => {
      post(`${API_URL}${API.EXPORT_DETAIL}${exportId}/`).then(async (res) => {
        const { exporttype, socialpath } = res.data || {};
        const isDownload = exporttype === "download";
        const isTikTok = exporttype === "tiktok";
        setIsDownload(isDownload);
        setIsTikTok(isTikTok);
        if (isDownload) {
          setLink(`${API_URL}record/${exportId}`);
          setIsLoading(false);
        } else if (!socialpath) {
          if (retryCountRef.current < maxRetries) {
            retryCountRef.current += 1;
            await proceedWait(3000);
            proceedNewApi();
          } else {
            setLink(isTikTok ? `${TIKTOK_URL}` : `${API_URL}record/${exportId}`);
            setisYoutubeFailed(true)
            setIsLoading(false);
          }
        } else {
          setLink(socialpath);
          setIsLoading(false);
        }
      }).catch(() => { });
    }

    proceedNewApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportId, email]);

  useEffect(() => {
    if (link && !isYoutubeFailed) {
      openUrl(link, false);
    }
  }, [link, isYoutubeFailed])

  return (
    <ConfirmationWrap>
      <Image src={`${STATIC_PATH}success.svg`} alt="success" />
      <Typography
        content={isDownload ? content.YOUR_VIDEO_EXPORTED_SUCCESSFULLY :
          isTikTok ?
            content.YOUR_VIDEO_PUBLISHED_SUCCESSFULLY_TIKTOK :
            content.YOUR_VIDEO_PUBLISHED_SUCCESSFULLY}
        font={font.mediumBase_21}
        color={vmTheme[theme].animoTextColor}
        enableTrim={false}
        align={"center"}
      />
      <Action
        text={content.OPEN_LINK}
        color={vmTheme[theme].polarColor}
        background={vmTheme[theme].secondaryBorderColor}
        hoverColor={vmTheme[theme].openHoverColor}
        width={"100%"}
        height="36px"
        padding="2px 0px 6px"
        font={font.mediumBase_21}
        borderRadius={"8px"}
        onClick={() => onClick(link)}
        isLoading={isLoading}
      />
      <Modal
        width="310px"
        height="170px"
        showModal={!isTikTok && isYoutubeFailed}
        preventClose={false}
        onClose={() => setisYoutubeFailed(false)}
        padding="30px 30px 10px"
        align={"center"}
      >
        <div>
          <Typography
            content={isTikTok ? content.YOUR_VIDEO_CANT_PUBLISHED_TIKTOK : content.YOUR_VIDEO_CANT_PUBLISHED_YOUTUBE}
            font={font.mediumBase_21}
            color={vmTheme[theme].animoTextColor}
            enableTrim={false}
            align={"center"}
          />
          <Action
            text="Watch Video"
            color={vmTheme[theme].polarColor}
            background={vmTheme[theme].secondaryBorderColor}
            hoverColor={vmTheme[theme].openHoverColor}
            width={"150px"}
            height="36px"
            padding="2px 0px 6px"
            font={font.mediumBase_21}
            borderRadius={"8px"}
            onClick={() => onClick(link)}
            marginRight="auto"
            marginLeft="auto"
          />
        </div>
      </Modal>
    </ConfirmationWrap>
  );
};

PublishSuccess.propTypes = {
  exportId: PropTypes.string,
  onClick: PropTypes.func
}

export default PublishSuccess;
